<template>
  <div class="accessmenetDetail_div">
    <a-row>
      <a-col :span="8">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.dealType')}}</div>
          <div class="value">
            <a-tooltip placement="top" :title="detail.dealType.split(',').map(e=>{return $t('deal.dealTypes.' + e)}).join(',')" v-if="detail.dealType.split(',').length > 1">
              <div class="trackTypeText" v-text="detail.dealType.split(',').map(e=>{return $t('deal.dealTypes.' + e)}).join(',')"></div>
            </a-tooltip>
            <a-tooltip placement="top" :title="$t('deal.dealTypes.' + detail.dealType)" v-else>
              <div class="trackTypeText" v-text="$t('deal.dealTypes.' + detail.dealType)"></div>
            </a-tooltip>
          </div>
        </div>
      </a-col>
      <a-col :span="10">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.demandArea')}}</div>
          <div class="value_1">
            {{detail.demandArea | NumberFormat}}
            <pt-unit-select type="area" v-model="detail.demandAreaUnit" :edit-mode="false"></pt-unit-select>
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.propertyType')}}</div>
          <div class="value">
            {{$t('deal.propertyTypes.' + detail.propertyType)}}
          </div>
        </div>
      </a-col>
    </a-row>

    <a-row>
      <a-col :span="8">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.budgetRent')}}</div>
          <div class="value">
            {{detail.budgetRent | NumberFormat}}
            <pt-unit-select type="rent" v-model="detail.budgetRentUnit" :edit-mode="false"></pt-unit-select>
          </div>
        </div>
      </a-col>
      <a-col :span="10">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealSource.sourceType')}}</div>
          <div class="value">
            {{ detail.sourceTypeName }}
          </div>
        </div>
      </a-col>
      <a-col :span="6">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.dealDetails.dealSource')}}</div>
          <div class="value">
            {{ detail.sourcePerson }}
          </div>
        </div>
      </a-col>
    </a-row>
    <a-row>
      <a-col :span="24">
        <div class="item">
          <div class="title">{{$t('deal.addDeal.brokerage.remarks')}}</div>
          <div class="value">{{detail.remarks}}</div>
        </div>
      </a-col>
    </a-row>
  </div>
</template>

<script>
import { findCascadingData } from '@/api/sys/datadict'
import customerApi from '@/api/mine/customer'

export default {
  name: 'assessmentDetail',
  props:{
    detail:{

    }
  },
  data(){
    return {
      allCityDatas:[],
      cityDatas:[],
      priorityOptions: [],
    }
  },
  mounted() {
    this.initCityData();
    this.initCustomerRelationShipOptions()
  },
  methods:{
    initCustomerRelationShipOptions(){
      customerApi.getCustomerRelationShipOptions().then(res=>{
        if(res.code == 1){
          this.priorityOptions = res.data
          this.priorityOptions.sort((a,b)=>{
            return a.listIndex - b.listIndex
          })
        }
      })
    },
    buildNewTree(tree,equalsValue){
      let stack = [tree]
      if(tree.value != equalsValue){
        for(let i = 0; i < tree.children.length; i++){
          if(tree.children[i].value == equalsValue){
            return stack
          }
        }
      }else{
        return stack
      }
    },
    initCityData(){
      let this_ = this
      findCascadingData("system.mansion_set.address",4).then(res=>{
        this_.allCityDatas = res.data
        let data
        for(let i = 0; i < res.data.length; i++){
          //只显示员工公司所在地
          data = this_.buildNewTree(res.data[i],this_.$store.getters.userInfo.companyDO.city.toLowerCase())
          if(data){
            break
          }
        }
        this_.cityDatas = data
      })
    },
  }
}
</script>

<style scoped lang="less">
.accessmenetDetail_div{
  background: #fafbfc;
  padding: 20px 24px;
  margin-top: 5px;
  .item{
    margin-bottom: 20px;
  }
  .title{
    font-size: 12px;
    color: #999999;
    letter-spacing: 0;
  }
  .value{
    font-size: 12px;
    color: #333333;
    letter-spacing: 0;

  }
  .value_1{
    font-size: 12px;
    color: #FABE00;
    letter-spacing: 0;
  }
}
</style>